import { Box, CardContent } from "@mui/joy";
import DarkCard from "./DarkCard";
import DarkTypography from "./DarkTypography";

type InvalidLinkCardProps = {
  title?: string;
  message?: string;
};

export default function InvalidLinkCard({
  title = "Lien non valide",
  message = "Ce lien est invalide.",
}: InvalidLinkCardProps) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: { xs: 2, sm: 3 },
        backgroundColor: "background.body",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: { xs: "100%", sm: 420 }, textAlign: "center" }}>
        <DarkCard dense>
          <CardContent>
            <DarkTypography level="title-md" colorVariant="accent" sx={{ fontWeight: 700, mb: 1 }}>
              {title}
            </DarkTypography>
            <DarkTypography level="body-sm" colorVariant="secondary" sx={{ lineHeight: 1.5 }}>
              {message}
            </DarkTypography>
          </CardContent>
        </DarkCard>
      </Box>
    </Box>
  );
}
